import { ValidationArguments, ValidatorConstraint, ValidatorConstraintInterface, Validator } from 'class-validator';
import { CustomCommonValidator } from './customCommonValidator';

@ValidatorConstraint()
export class SupplierDynamicPropertyValidator extends CustomCommonValidator implements ValidatorConstraintInterface {
	validate(dynamicProperties: any, validationArguments: ValidationArguments) {
		let properties: string[] = Object.getOwnPropertyNames(dynamicProperties);
		let result: boolean = true;
		const validator = this.getValidator();
		this.message = '';
		if (properties.find(p => p == 'language') != null) {
			let language: any = dynamicProperties['language'] as any;
			if (!validator.isNotEmpty(language)) {
				this.message = this.message.concat('Language is required');
				result = false;
			}
		}
		return result;
	}

	defaultMessage(args: ValidationArguments) { // here you can provide default error message if validation failed
		return this.message;
	}
}



// WEBPACK FOOTER //
// ./src/core/customValidator/supplierDynamicPropertyValidator.ts